import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, intro, align = "left", dark = false }) => (
  <Reveal className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <p className={`eyebrow ${dark ? "!text-sage" : ""}`} data-testid="section-eyebrow">
      {eyebrow}
    </p>
    <h2
      className={`mt-4 font-serif text-3xl sm:text-4xl lg:text-[2.75rem] font-semibold tracking-tight leading-[1.12] ${
        dark ? "text-ivory" : "text-atento-blue"
      }`}
    >
      {title}
    </h2>
    {intro && (
      <p
        className={`mt-5 text-base sm:text-lg leading-relaxed ${
          dark ? "text-ivory/75" : "text-charcoal/70"
        }`}
      >
        {intro}
      </p>
    )}
  </Reveal>
);
